import React, { useState, useEffect, useRef } from "react";
import { unified } from "unified";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import rehypeReact from "rehype-react";
import { MdKeyboardArrowDown } from "react-icons/md";

const FAQ: React.FC<{
  readonly question: string | null;
  readonly answer: string | null;
  readonly slug: string | null;
}> = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const calculateValues = () => {
      if (container.current) {
        setHeight((open && container.current.scrollHeight) || 0);
      }
    };

    calculateValues();

    window.addEventListener("resize", calculateValues);

    return () => {
      window.removeEventListener("resize", calculateValues);
    };
  }, [open]);

  const vfile = answer
    ? unified()
        .use(remarkParse)
        .use(remarkRehype)
        .use(rehypeReact, { createElement: React.createElement })
        .processSync(answer)
    : null;

  return (
    <div className="relative mb-4 border-b border-clhbid-silver">
      <button
        className="flex w-full justify-between text-left"
        aria-label={`${open ? "Close" : "Open"} Dropdown`}
        onClick={() => setOpen(!open)}
      >
        <p className="m-0 grow pb-4 pr-4 text-lg italic lg:pr-20">{question}</p>
        <div className="">
          <MdKeyboardArrowDown
            className={[
              "h-6 w-6 fill-clhbid-orange lg:h-8 lg:w-8",
              open ? "rotate-180" : "",
            ].join(" ")}
          />
        </div>
      </button>
      <div
        ref={container}
        style={{ maxHeight: `${height}px` }}
        className={[
          "overflow-hidden transition-[max-height,visibility]",
          open ? "visible" : "invisible",
        ].join(" ")}
      >
        {vfile && vfile.result}
      </div>
    </div>
  );
};

export default FAQ;
